import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, List, Paper } from '../components/ui';
import PageHeader from '../components/common/PageHeader';
import { NotificationsIcon } from '../components/icons';
import NotificationItem from '../components/notifications/NotificationItem';
import { RootState } from '../types';
import { setNotifications, markAsRead, setUnreadCount } from '../features/notifications/notificationsSlice';
import { notificationsClient } from '../apis/client-instances';
import { alert } from '../hooks/function';
import { useSnackbar } from 'notistack';
import { EmptyState } from '../components/common';

const Notifications: React.FC = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const notifications = useSelector((state: RootState) => state.notifications.notifications);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    try {
      // Fetch top 50 notifications
      const response = await notificationsClient.getNotifications(50, 0, false);
      const data = await response.data.text();
      const parsed = JSON.parse(data);
      dispatch(setNotifications(parsed.notifications || []));

      // Mark all as read
      const unreadIds = parsed.notifications
        ?.filter((n: any) => !n.isRead)
        .map((n: any) => n.id) || [];

      if (unreadIds.length > 0) {
        await notificationsClient.markAsRead({ notificationIds: unreadIds });
        dispatch(markAsRead(unreadIds));
        dispatch(setUnreadCount(0));
      }
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
      alert(enqueueSnackbar, 'Failed to load notifications', 'error');
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <PageHeader
        icon={<NotificationsIcon />}
        title="Notifications"
      />

      {notifications.length === 0 ? (
        <EmptyState
          icon={<NotificationsIcon sx={{ fontSize: 100, color: 'grey.400' }} />}
          title="No notifications yet"
          subtitle="You'll see notifications here when there are updates"
        />
      ) : (
        <Paper sx={{ overflow: 'hidden' }}>
          <List sx={{ py: 0 }}>
            {notifications.map((notification) => (
              <NotificationItem key={notification.id} notification={notification} />
            ))}
          </List>
        </Paper>
      )}
    </Container>
  );
};

export default Notifications;
